<div class="spinner-wrapper">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>